import styled from 'styled-components';
import React, { useState, useEffect } from 'react';
// import TopList from './components/TopList';
import UpDetailesList from './components/UpDetailesList';
import DSForm from './components/DSForm';
import HistoryList from './components/HistoryList';
import { Row, Col, Typography, Grid } from 'antd';
import './MakeRequestStyle.less';
import { useTranslation } from 'react-i18next';
import GreetingSection from '../../components/navbar/GreetingSection';
import placeholderImg from 'assets/images/placeholder-image.svg';
import imgUrl from 'assets/images/foto.svg';
import bannerUrl from 'assets/images/MakeRequest/banner.svg';
import forward from 'assets/images/forward-arrow.svg';
import Tab from './components/Tab';
import { useLocation } from 'react-router-dom';
import CloseGrey from 'assets/images/close-grey.svg';
import { useGetHideAutopay } from 'all-in-one-shared-api';
import { useKeycloakReady } from 'hooks/useKeycloakReady';
import { useNavigate } from 'react-router-dom';

const SupportPageContainer = styled.div`
  margin: 0;
  dispay: flex;
`;
const { Text } = Typography;
interface LocationState {
  tabs?: number;
  policyNo?: string;
  companyCode?: string;
}
function MakeRequestPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [tabIndex, setTabIndex] = useState(0);
  const imageUrl = true;
  const location = useLocation();
  const { tabs, policyNo, companyCode } = (location.state as LocationState) ?? {};
  const { useBreakpoint } = Grid;
  const { xl, sm } = useBreakpoint();
  const { token } = useKeycloakReady();
  const [showAdv, setShowAdv] = useState(true);
  const [randoms, setRandoms] = useState(0);
  const { shouldFetch, data } = useGetHideAutopay('useGetHideAutopay' + randoms, token ?? '');
  useEffect(() => {
    if (tabs) {
      setTabIndex(tabs);
    }
  }, [tabs]);
  useEffect(() => {
    if (tabIndex == 0) {
      setRandoms(Math.random());
      shouldFetch(true);
    }
  }, [tabIndex, shouldFetch]);
  useEffect(() => {
    if (data) {
      setShowAdv(data.message == 'Y' ? true : false);
    }
  }, [data]);
  return (
    <SupportPageContainer
      style={{
        position: 'relative',
      }}
      className="MakeRequest"
    >
      <GreetingSection
        pageName={tabIndex == 0 ? t('life.MakeRequest.tittle') : t('life.MakeRequest.historytittle')}
        showicon={true}
      />
      <Tab
        values={[t('life.MakeRequest.tittle'), t('life.MakeRequest.historytittle')]}
        selectedIndex={tabIndex}
        onTabPress={(index) => {
          setTabIndex(index);
        }}
      />
      {tabIndex == 1 ? (
        <HistoryList policyNo={policyNo} cCode={companyCode}></HistoryList>
      ) : (
        <div className="MakeRequestContent">
          <Row gutter={[{ xs: 8, sm: 24, lg: 24 }, 16]} wrap className="MakeRequestFormRow" justify="center">
            <Col xs={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 12 }}>
              <UpDetailesList></UpDetailesList>
            </Col>
            <Col xs={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 12 }}>
              <DSForm></DSForm>
            </Col>
          </Row>
          {/* <Row wrap className="MakeRequestFormRow" justify="center">
            <Col span="22">
              <Text>{t('life.Payment.nopayment')}</Text>
            </Col>
          </Row> */}
          {showAdv && (
            <Row
              gutter={[{ xs: 8, sm: 16, md: 24 }, 16]}
              justify="space-between"
              wrap
              style={{
                marginTop: '40px',
              }}
              className="advertisement"
            >
              <div
                className={!sm ? 'to-center' : ''}
                style={{
                  backgroundColor: 'white',
                  position: 'relative',
                  borderRadius: '8px',
                  width: xl ? '352px' : sm ? '348px' : 'calc(100% - 28px)',
                  // marginLeft: '10px',
                  display: 'flex',
                  flexDirection: xl ? 'column' : 'row',
                }}
              >
                {!imageUrl ? (
                  <img
                    src={placeholderImg}
                    width={xl ? '100%' : '158px'}
                    height={xl ? '180' : '176'}
                    style={{ border: 'none', backgroundColor: 'pink' }}
                  />
                ) : (
                  <img
                    src={xl ? imgUrl : bannerUrl}
                    width={xl ? '100%' : '158px'}
                    height={xl ? '106' : '176'}
                    style={{ border: 'none' }}
                  />
                )}
                <div
                  style={{
                    padding: !xl ? '27.5px 8px 27.5px 19px' : '8px',
                    overflow: 'hidden',
                    width: '100%',
                    position: 'relative',
                  }}
                >
                  <Text
                    className="text-show"
                    style={{
                      fontSize: xl ? '20px' : '17px',
                      fontFamily: 'Roboto500',
                      width: '100%',
                      color: '#C21B17',
                      marginBottom: '14px',
                    }}
                  >
                    {t('life.MakeRequest.setupautopay')}
                  </Text>
                  <Text
                    style={{
                      fontSize: xl ? '17px' : '15px',
                      fontFamily: 'Roboto400',
                      width: '100%',
                      display: 'inline-block',
                      color: '#6F7072',
                    }}
                  >
                    {t('life.MakeRequest.NeverMiss')}
                  </Text>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      cursor: 'pointer',
                    }}
                    onClick={() => navigate('/ChangePaymentArrangement')}
                  >
                    <Text style={{ fontSize: xl ? '20px' : '17px', fontFamily: 'Roboto500', color: '#6F7072' }}>
                      {t('home.requestKnowMore')}
                    </Text>
                    <img src={forward} style={{ marginLeft: '10px' }} />
                  </div>
                  {!xl && (
                    <img
                      onClick={() => {
                        setShowAdv(false);
                      }}
                      style={{ position: 'absolute', right: '7px', top: '21px' }}
                      src={CloseGrey}
                      alt=""
                    />
                  )}
                </div>
              </div>
            </Row>
          )}
        </div>
      )}
    </SupportPageContainer>
  );
}

export default MakeRequestPage;
